import homeP from "../_ApiConn/apiHomePage";

const getHomePage = async (cityId) => {
    let dFromF = await homeP.getHomePage(cityId);
    return (dFromF.data[0]);
}

export default {
    getHomePage

};